import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from '@s7ui-kit/s7ui-kit';
import classNames from 'classnames';
import LazyLoad from 'react-lazyload';

import pushGA from '../../../services/utils/pushGA';
import getResizeImageUrl from "../../../services/utils/getResizeImageUrl";
import { CDN_PATH } from '../../../constants/variables';

import styles from './shop-item-card.css';

const CabinService = process.env.REACT_APP_CABIN_SERVICE;

const ShopItemCard = ({ item, gaName, targetNewTab, itemClass, lang, onClick }) => {
    const src = item.thumbnail ? getResizeImageUrl({
        imageCabinId: item.thumbnail
    }) : getResizeImageUrl({
        imageAbsoluteUrl:`${CDN_PATH === '/' ? location.origin : CDN_PATH}${CabinService}/media/by-path/raw/images/newmainpage/default-pic-news.jpg`
    });

    const linkClickHandler = (event) => {
        event.preventDefault();

        const { url } = item;

        pushGA(
            `PORTAL ${gaName}`,
            'Click_GoToShop',
            url,
            {
                eventValue: 0,
                eventInteraction: 0,
                eventUX: 'TYPE:card',
            }
        );
        onClick();
        targetNewTab ? window.open(url, '_blank') : window.location.href = url;
    };

    return (
        <a
            href={item.url}
            onClick={linkClickHandler}
            className={classNames(styles.shopItemCard, itemClass)}
        >
            <LazyLoad>
                <div
                    className={styles.shopItemCardImg}
                    style={{backgroundImage: `url(${src})`}}
                >
                    {item.newProduct && (
                        <div className={styles.shopItemCardNewBadge}>new</div>
                    )}
                </div>
            </LazyLoad>
            <div className={styles.shopItemCardInfo}>
                <div className={styles.shopItemCardInfoText}>
                    <div className={styles.shopItemCardPrices}>
                        <div className={styles.shopItemCardCurrentPrice}>
                            {item.price.toLocaleString(lang)} ₽
                        </div>
                        {item.oldPrice && (
                            <div className={styles.shopItemCardOldPrice}>
                                {item.oldPrice.toLocaleString(lang)} ₽
                            </div>
                        )}
                    </div>
                    <p
                        className={styles.shopItemCardTitle}
                        dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                </div>
            </div>
        </a>
    )
};

const mapStateToProps = state => ({
    lang: state.App.lang
});

ShopItemCard.propTypes = {
    gaName: PropTypes.string,
    item: PropTypes.object,
    itemClass: PropTypes.string,
    targetNewTab: PropTypes.bool,
    onClick:PropTypes.func
};

ShopItemCard.defaultProps = {
    item: {},
    itemClass: '',
    targetNewTab: false,
    onClick:()=>{}
};

export default injectIntl(connect(mapStateToProps)(ShopItemCard));
